import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=9043c780&scoped=true"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"
import style0 from "./Email.vue?vue&type=style&index=0&id=9043c780&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9043c780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9043c780')) {
      api.createRecord('9043c780', component.options)
    } else {
      api.reload('9043c780', component.options)
    }
    module.hot.accept("./Email.vue?vue&type=template&id=9043c780&scoped=true", function () {
      api.rerender('9043c780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account-settings/Email.vue"
export default component.exports